import { combineReducers, configureStore, PreloadedState } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

import offersReducer from "./offers-slice";
import configReducer from "./config-slice";
import userReducer from "./user-slice";
import cartReducer from "./cart-slice";
import creditCardsReducer from "./credit-cards-slice";

import { offersApi } from "services/offersApiService";
import { getEnvFromHost } from "utils/getEnvFromHost";
import { ENV } from "types/envs";

export const rootReducer = combineReducers({
  offers: offersReducer,
  config: configReducer,
  user: userReducer,
  cart: cartReducer,
  creditCards: creditCardsReducer,
  [offersApi.reducerPath]: offersApi.reducer,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const devToolsEnabled = (): boolean => {
  const {
    location: { host },
  } = window;

  const env: ENV = getEnvFromHost(host);

  return env === "PROD" ? false : true;
};

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: persistedReducer,
    devTools: devToolsEnabled(),
    middleware: [thunkMiddleware, offersApi.middleware],
    preloadedState,
  });
};

export const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>;

export type AppStore = ReturnType<typeof setupStore>;

export type AppDispatch = AppStore["dispatch"];
